import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spacesAfterCommas',
  standalone: false
})
export class SpacesAfterCommasPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value && value.replace(/,/g, ', ');
  }

}
